import {createSlice, PayloadAction} from '@reduxjs/toolkit';

export const developerSlice = createSlice({
  name: 'developer',
  initialState: {
    isDevBlockHidden: false,
  },
  reducers: {
    setIsDevBlockHidden: (state, action: PayloadAction<boolean>) => {
      state.isDevBlockHidden = action.payload;
    },
  },
});

export const {setIsDevBlockHidden} = developerSlice.actions;
